import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { Text } from "@nxt-costco-com/forge-components";
import { CostcoBox } from "../../../Util/CostcoBox.js";
import { ObservableProductTileUI } from "./ObservableProductTileUI.js";
import { batchedTiles } from "./utils.js";
function ProductTiles({
  disableBottomControls,
  maxProductTileImageHeight,
  maxProductTileImageWidth,
  minProductTileImageWidth,
  productTileContainerSx,
  productTileMaxLineNumber,
  productTileNumberSeparator,
  analytics,
  carouselItems,
  isLWResponseData,
  criteoDataSourceAttr,
  dataPrivate,
  displayMultipleTiles,
  finalProductTileSx,
  hideReviewStarValue,
  inventoryAware,
  isHorizontal,
  isProductDetailsPage,
  locale,
  productData,
  showActionButton,
  showReviews,
  showSlideNumber,
  variant,
  pageType,
  carouselTitle,
  isCriteo,
  product_tile_data_source
}) {
  if (!displayMultipleTiles) {
    return carouselItems == null ? void 0 : carouselItems.map((carouselItem, index) => {
      let itemNumber;
      let lwData;
      let productApiResponse;
      if (isLWResponseData) {
        lwData = carouselItem;
        itemNumber = lwData.group_id || lwData.item_number || lwData.item_location_itemNumber;
      } else {
        productApiResponse = carouselItem;
        itemNumber = productApiResponse == null ? void 0 : productApiResponse.itemNumber;
      }
      const showCarouselIndexText = isHorizontal && disableBottomControls || showSlideNumber;
      const tileIndex = `${index + 1}/${carouselItems == null ? void 0 : carouselItems.length}`;
      const showCarouselAriaText = productTileNumberSeparator && showCarouselIndexText;
      return /* @__PURE__ */ jsx(
        ObservableProductTileUI,
        {
          carouselIndexAriaText: showCarouselAriaText ? `${index + 1} ${productTileNumberSeparator} ${carouselItems == null ? void 0 : carouselItems.length}` : void 0,
          carouselIndexText: showCarouselIndexText ? tileIndex : void 0,
          configData: productData == null ? void 0 : productData.configData,
          maxImageHeight: maxProductTileImageHeight || (finalProductTileSx == null ? void 0 : finalProductTileSx.maxHeight),
          productApiResponse,
          allowBatchApi: ((productApiResponse == null ? void 0 : productApiResponse.inventoryItemNumbers) || []).length === 1,
          lwData,
          analytics,
          carouselTitle,
          containerSx: productTileContainerSx,
          criteoDataSourceAttr,
          dataPrivate,
          hideReviewStarValue,
          inventoryAware,
          isHorizontal,
          isProductDetailsPage,
          itemNumber,
          locale,
          maxProductTileImageWidth,
          minProductTileImageWidth,
          pageType,
          productTileMaxLineNumber,
          productTileSx: finalProductTileSx,
          product_tile_data_source,
          showActionButton,
          showReviews,
          variant,
          isCriteo
        },
        `carouselProductTile-${itemNumber}`
      );
    });
  } else {
    const batchedItems = batchedTiles(
      carouselItems,
      2
    );
    return batchedItems.map((batch, index) => {
      const showCarouselIndexText = isHorizontal && disableBottomControls || showSlideNumber;
      const tileIndex = `${index + 1}/${batchedItems == null ? void 0 : batchedItems.length}`;
      const showCarouselAriaText = productTileNumberSeparator && showCarouselIndexText;
      return /* @__PURE__ */ jsxs(
        CostcoBox,
        {
          sx: {
            display: "flex",
            flexDirection: "column"
          },
          children: [
            /* @__PURE__ */ jsx(
              CostcoBox,
              {
                sx: {
                  display: "flex",
                  flexDirection: "row"
                },
                children: batch.map((carouselItem) => {
                  let itemNumber;
                  let lwData;
                  let productApiResponse;
                  if (isLWResponseData) {
                    lwData = carouselItem;
                    itemNumber = lwData.item_number || lwData.item_location_itemNumber;
                  } else {
                    productApiResponse = carouselItem;
                    itemNumber = productApiResponse == null ? void 0 : productApiResponse.itemNumber;
                  }
                  return /* @__PURE__ */ jsx(
                    ObservableProductTileUI,
                    {
                      configData: productData == null ? void 0 : productData.configData,
                      maxImageHeight: maxProductTileImageHeight || (finalProductTileSx == null ? void 0 : finalProductTileSx.maxHeight),
                      maxProductTileImageWidth,
                      minProductTileImageWidth,
                      productApiResponse,
                      lwData,
                      productTileMaxLineNumber,
                      productTileSx: finalProductTileSx,
                      analytics,
                      containerSx: productTileContainerSx,
                      criteoDataSourceAttr,
                      dataPrivate,
                      hideReviewStarValue,
                      inventoryAware,
                      isHorizontal,
                      itemNumber,
                      locale,
                      pageType,
                      showActionButton,
                      showReviews,
                      variant,
                      isProductDetailsPage: true
                    },
                    `carouselProductTile-${itemNumber}`
                  );
                })
              }
            ),
            !!showCarouselIndexText && /* @__PURE__ */ jsxs(Fragment, { children: [
              /* @__PURE__ */ jsx(
                Text,
                {
                  sx: {
                    textAlign: "right"
                  },
                  "aria-hidden": "true",
                  color: "medium",
                  children: tileIndex
                }
              ),
              !!showCarouselAriaText && /* @__PURE__ */ jsx(
                Text,
                {
                  sx: {
                    display: "none",
                    textAlign: "right"
                  },
                  color: "medium",
                  id: `carouselProductTile-${index}-carouselIndexAriaText`,
                  children: `${index + 1} ${productTileNumberSeparator} ${batchedItems == null ? void 0 : batchedItems.length}`
                }
              )
            ] })
          ]
        },
        index
      );
    });
  }
}
export {
  ProductTiles
};
